<h1 class="mt-5 mb-3">Nicola Wealth Philanthropy: Share the Pie</h1>
<p>Nicola Wealth is deeply rooted in giving back and Sharing the Pie is the cornerstone of who we are, how we operate, and how we show up in the community. We are dedicated to creating lasting positive change and fully engage our staff in these efforts.</p>
<p>Our philanthropic vision can be broken down into three pillars of direct community support:</p>

<div class="peach-section p-4 {{hovered_area}}">
  <div class="row">
    <div class="col-md-6">
      <div class="flex-section pl-lg-4">
        <div id="text-section-1" (mouseenter)="hoverArea(1)" (mouseleave)="hoverArea(0)">
          <img src="/assets/PGF/nw-pgf.svg" alt="Nicola Wealth Private Giving Foundation">
          <p>Nicola Wealth Private Giving Foundation</p>

          <p class="collapsible">Established in 1996, the Nicola Wealth Private Giving Foundation manages 450+ Donor Advised Funds, (*as at July 2024) aligning financial planning and philanthropic goals with strategic charitable impact.
          </p>
        </div>
        <div id="text-section-2" (mouseenter)="hoverArea(2)" (mouseleave)="hoverArea(0)">
          <img src="/assets/PGF/nw-gives-back.svg" alt="Nicola Wealth Gives Back">
          <p>Nicola Wealth Gives Back</p>
          <p class="collapsible">With a focus on advancing social, economic, and health equity for people to live their best possible lives, we align our resources with our values, and are committed to effecting positive social change. Between 2016 - 2023 Nicola Wealth disbursed $13.5M to over 300 organizations and supported 1000+ staff volunteer hours.</p>
        </div>
        <div id="text-section-3" (mouseenter)="hoverArea(3)" (mouseleave)="hoverArea(0)">
          <img src="/assets/PGF/nw-sponsorships.svg" alt="Sponsorships">
          <p>Nicola Wealth Sponsorships</p>
          <p class="collapsible">Through our philanthropic sponsorships, our commitment to giving back has allowed us to foster strategic charitable engagement leading to tangible, transformative relationships with our community partners.</p>
        </div>
      </div>
    </div>
    <div class="col-md-6 pie">
      <img src="/assets/PGF/Pie animation - def.png" alt="Pie animation - default">
      <img src="/assets/PGF/Pie animation - pink.png" id="pie-section-1" alt="Pie animation - pink">
      <img src="/assets/PGF/Pie animation - green.png" id="pie-section-2" alt="Pie animation - green">
      <img src="/assets/PGF/Pie animation - orange.png" id="pie-section-3" alt="Pie animation - orange">

      <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
        <path d="M 0 0 H 271 L 512 512 L 187 1024 H 0 V 0" (mouseenter)="hoverArea(1)" (mouseleave)="hoverArea(0)"/>
        <path d="M 187 1024 H 1024 V 512 H 512 L 187 1024" (mouseenter)="hoverArea(2)" (mouseleave)="hoverArea(0)"/>
        <path d="M 271 0 H 1024 V 512 H 512 L 271 0" (mouseenter)="hoverArea(3)" (mouseleave)="hoverArea(0)"/>
      </svg>

    </div>
  </div>
</div>